import React, {useState} from "react";
import {component_tool, framework_tool, utils_tool} from '@/tool'

import './index.less'

const {WizOssUpload, ossFileUtils} = framework_tool;
const {WizIcon, WizButton} = component_tool;
const {getOssImgResizeUrl} = ossFileUtils


const Album = ({fileInfoList = [], onChange}) => {
  const [selected, setSelected] = useState([])

  return (
    <div>
      <div style={{display: 'flex', marginBottom: 10}}>
        <WizOssUpload initialValue={[]} accept={".jpg, .jpeg, .png"} multiple={true} showUploadList={false}
                      onChange={(values) => onChange && onChange(values, 'add')}>
          <WizButton>上传照片</WizButton>
        </WizOssUpload>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <WizButton disabled={!selected.length} onClick={() => onChange && onChange(selected, 'remove')}>删除</WizButton>
      </div>

      <div>
        {fileInfoList.map(item => {
          let tmp = selected.indexOf(item?.fileId) !== -1;
          return (
            <Item {...item} selected={tmp} onClick={() => {
              if (item?.fileId) {
                if (tmp) {
                  setSelected(selected => selected.filter(fileId => fileId !== item.fileId))
                } else {
                  setSelected(selected => [...selected, item.fileId])
                }
              }
            }}/>
          )
        })}
      </div>
    </div>
  )
}

const Item = ({fileId, fileUri, fileName = '', selected, onClick}) => {
  return (
    <div className={'class-album-item'} onClick={() => onClick && onClick(fileId)}>
      <div className={'class-album-item-body'}>
        <img alt={fileName} className={'class-album-item-image'} src={fileId ? getOssFilePath(fileId + "?process=image/format,jpg") : ''} onError={event => {
          event.target.src = constants.files.sys_img_non_existent
        }}/>
        <p className={'class-album-item-filename'}>{fileName}</p>
      </div>
      {selected ?
        <div className={'class-album-item-selected'}>
          <WizIcon className={'class-album-item-selected-icon'} type="check"/>
        </div> : null}
    </div>
  )
}

export {
  Album,
  Item,
}
